import React, { useContext } from 'react'
import { Switch } from 'react-router-dom'

import { PrivateRoutes } from './Index'

import ProductFiltersContextProvider from '../context/ProductFiltersContext'
import { AuthContext } from '../context/AuthContext'

import Product from '../pages/Products/Index'

export default function FactoryRoutes (): JSX.Element {
  const { auth } = useContext(AuthContext)
  return (
    <ProductFiltersContextProvider>
      <Switch>
        <PrivateRoutes path="/produtos" component={Product} auth={auth} />
      </Switch>
    </ProductFiltersContextProvider>
  )
}
